'use client'

import { m, useMotionValue, useSpring } from 'framer-motion'
import { useEffect, useState } from 'react'

export default function CustomCursor() {
  const [isHovering, setIsHovering] = useState(false)
  const cursorX = useMotionValue(-100)
  const cursorY = useMotionValue(-100)

  const springConfig = { damping: 25, stiffness: 200 }
  const cursorXSpring = useSpring(cursorX, springConfig)
  const cursorYSpring = useSpring(cursorY, springConfig)

  useEffect(() => {
    const moveCursor = (e: MouseEvent) => {
      cursorX.set(e.clientX - 16)
      cursorY.set(e.clientY - 16)
    }

    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      if (
        target.tagName === 'BUTTON' ||
        target.tagName === 'A' ||
        target.closest('button') ||
        target.closest('a')
      ) {
        setIsHovering(true)
      } else {
        setIsHovering(false)
      }
    }

    window.addEventListener('mousemove', moveCursor)
    window.addEventListener('mouseover', handleMouseOver)

    return () => {
      window.removeEventListener('mousemove', moveCursor)
      window.removeEventListener('mouseover', handleMouseOver)
    }
  }, [cursorX, cursorY])

  return (
    <>
      <m.div
        className="fixed w-8 h-8 pointer-events-none z-[9999] mix-blend-difference hidden md:block"
        style={{
          left: cursorXSpring,
          top: cursorYSpring,
        }}
      >
        <m.div
          className="w-full h-full rounded-full border-2 border-batman-gold"
          animate={{
            scale: isHovering ? 1.5 : 1,
            opacity: isHovering ? 0.5 : 1,
          }}
          transition={{ duration: 0.15 }}
        />
      </m.div>
      <m.div
        className="fixed w-1 h-1 rounded-full bg-batman-gold pointer-events-none z-[9999] hidden md:block"
        style={{
          left: cursorXSpring,
          top: cursorYSpring,
          x: 15,
          y: 15,
        }}
      />
    </>
  )
}
